import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "DayCard_cardContent" }
const _hoisted_2 = { class: "DayCard_leftSide" }
const _hoisted_3 = { class: "DayCard_dayName ui-txt-lg" }
const _hoisted_4 = { class: "DayCard_cardDate ui-txt-sm" }
const _hoisted_5 = { class: "DayCard_rightSide" }
const _hoisted_6 = { class: "DayCard_today" }
const _hoisted_7 = {
  key: 0,
  class: "DayCard_todayLabel ui-txt-md"
}
const _hoisted_8 = {
  key: 0,
  class: "DayCard_placeDetails ui-txt-xs"
}
const _hoisted_9 = { class: "DayCard_parkingSpace" }
const _hoisted_10 = { class: "ui-txt-sm" }
const _hoisted_11 = { class: "DayCard_floorNumber" }
const _hoisted_12 = { class: "ui-txt-sm" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "DayCard_diagonalBox" }, null, -1)
const _hoisted_14 = { class: "DayCard_rightContent" }
const _hoisted_15 = { class: "DayCard_freeSpaces ui-txt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    disabled: _ctx.isDisabled,
    class: _normalizeClass({
      'DayCard': true,
      'is-today': _ctx.isToday,
      'is-reserved': _ctx.isReservedByMe,
    })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formattedDayOfWeek), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formattedDate), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.isToday)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('DayCard.today')), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isReservedByMe)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.$t('DayCard.space')) + ": ", 1),
                      _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.day.reservations[0].parkingSpace.number), 1)
                    ]),
                    _createElementVNode("span", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.$t('DayCard.floor')) + ": ", 1),
                      _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.day.reservations[0].parkingSpace.floor), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isReservedByMe && !_ctx.isGuest)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('DayCard.free')) + ": " + _toDisplayString(_ctx.day.freeParkingSpacesCount), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["disabled", "class"]))
}